import script from "./CreateUpdateClientImages.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateUpdateClientImages.vue?vue&type=script&setup=true&lang=js"

import "./CreateUpdateClientImages.vue?vue&type=style&index=0&id=8d17c31e&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8d17c31e"]])

export default __exports__